import type { HTMLAttributes } from 'react';

import { cx } from './shared';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  shape?: 'line' | 'title' | 'control' | 'block' | 'circle';
}

const shapeClass = {
  line: 'h-4 w-full rounded-control',
  title: 'h-8 w-3/5 rounded-control',
  control: 'h-control-comfortable w-full rounded-control',
  block: 'h-32 w-full rounded-surface',
  circle: 'h-control-comfortable w-control-comfortable rounded-full',
};

export function Skeleton({ shape = 'line', className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cx('so-skeleton', shapeClass[shape], className)}
      {...rest}
    />
  );
}
